import React, {useEffect, useState} from 'react';
import PageForm from "components/pageForm";
import SubNavbar from "components/SubNavbar/SubNavbar";
import {ArrowLeft, CrossIcon, Localisation, User, Euro, Calendar, Clock, Building, PhoneIcon} from "assets/icons";
import {useNavigate, useParams} from "react-router-dom";
import ApiDataBase from 'server'
import Button from "components/button";
import {dateToEpoch, dateWordShort} from "helper/helper";
import UseContext from "hooks/useContext";
import {statutMission} from "helper/helper";
import ScheduleWeekListMission from "../components/ScheduleWeekList/ScheduleWeekListMission";
import useModal from "../components/modal/useModal";
import Chip from "components/chip/chip";
import RatingTempWorker from "components/ratingTempWorker/ratingTempWorker";

const MissionFiche = () => {
    const {companyData, setObjID, setMissionTitle, setMissionId} = UseContext()
    const { toggle } = useModal();
    const [infoMission, setInfoMission] = useState({})
    const [showTools, setShowTools] = useState(false)
    const [visibilityTools, setVisibilityTools] = useState(3)
    const [showLicences, setShowLicences] = useState(false)
    const [visibilityLicences, setVisibilityLicences] = useState(3)
    const [scheduleWeeks, setScheduleWeeks] = useState([])
    const [scheduleWeeksProv, setScheduleWeeksProv] = useState([])
    const [scheduleWeekDisplay, setScheduleWeekDisplay] = useState(0)
    const [isWaiting, setIsWaiting] = useState(true);
    const [assignedUser, setAssignedUser] = useState(null);

    const statusObj = statutMission(infoMission?.duration)
    const navigate = useNavigate()
    const {id} = useParams()

    // Mapping du statut vers les couleurs du Chip
    const getStatusConfig = (statusText) => {
        if (statusText?.includes('cours')) return { color: 'SUCCESS', label: 'En cours' };
        if (statusText?.includes('venir')) return { color: 'PRIMARY', label: 'À venir' };
        return { color: 'SECONDARY', label: 'Terminée' };
    }
    const statusConfig = getStatusConfig(statusObj?.text)

    useEffect(() => {
        setIsWaiting(true)
        ApiDataBase.getMissionInfo({id},
            (data) => {
                setInfoMission(data ?? {})
                setIsWaiting(false);
                if (data?.title) setMissionTitle(data.title);
                if (data?.id_mission) setMissionId(data.id_mission);
                
            },
            (err) => console.log(err))
    }, [id, setMissionTitle, setMissionId])

    useEffect(() => {
        return () => {
            setMissionTitle('');
            setMissionId('');
        };
    }, [setMissionTitle, setMissionId])

    // Récupérer les infos de l'intérimaire assigné depuis infoMission
    useEffect(() => {
        if (infoMission?.user_assigned) {
            // Si user_assigned est un objet avec firstname et lastname (nouveau format API)
            if (infoMission.user_assigned.firstname || infoMission.user_assigned.lastname) {
                setAssignedUser({
                    firstname: infoMission.user_assigned.firstname,
                    lastname: infoMission.user_assigned.lastname,
                    _id: infoMission.user_assigned._id || infoMission.user_assigned
                });
            } else {
                // Fallback sur les anciennes sources de données
                const userData = infoMission?.userInfo?.[0] 
                    || infoMission?.user_assigned_infos 
                    || infoMission?.employee?.[0]
                    || null;
                setAssignedUser(userData);
            }
        } else {
            setAssignedUser(null);
        }
    }, [infoMission])

    useEffect(() => {
        ApiDataBase.getScheduleByMission({id: id},
            (data) => setScheduleWeeksProv(data),
            (err) => console.log(err))
    }, [infoMission])

    useEffect(() => {
        if(scheduleWeeksProv.length > 0) {
            scheduleWeeksProv.sort((a, b) => a.week_number - b.week_number)
            let isAWeekChosen = false;
            
            for (let i = 0; i < scheduleWeeksProv.length; i++) {
                scheduleWeeksProv[i].days.sort((a, b) => a.date - b.date)
                const number_week = ('0' + (parseInt(scheduleWeeksProv[i].week_number) + 1)).slice(-2)
                scheduleWeeksProv[i].name = `Semaine ${number_week}`
                scheduleWeeksProv[i].isNext = !!scheduleWeeksProv[i + 1];
                scheduleWeeksProv[i].isPrev = !!scheduleWeeksProv[i - 1];

                let isHidden = true;
                for (let j = 0; j < scheduleWeeksProv[i].days.length; j++) {
                    const scheduleDate = dateToEpoch(scheduleWeeksProv[i].days[j].date)
                    const today = dateToEpoch(new Date())
                    if(scheduleDate === today){
                        setScheduleWeekDisplay(i)
                        isHidden = false;
                        isAWeekChosen = true;
                    }
                }
                scheduleWeeksProv[i].isHidden = isHidden;
                scheduleWeeksProv[i].isActualWeek = !isHidden;
            }
            if(!isAWeekChosen) scheduleWeeksProv[0].isHidden = false;
            setScheduleWeeks(scheduleWeeksProv);
        }
    }, [scheduleWeeksProv])

    const handleShowExp = () => {
        setShowTools(!showTools)
        setVisibilityTools(prev => showTools ? prev - 3 : prev + 3)
    }
    
    const handleShowLicences = () => {
        setShowLicences(!showLicences)
        setVisibilityLicences(prev => showLicences ? prev - 3 : prev + 3)
    }

    const shouldShowTrashButton = (mission) => {
        if (mission.status === 'cancel' || mission.status === 'delete') return false
        const now = new Date();
        const startDate = new Date(mission.duration.datestart);
        const endDate = new Date(mission.duration.dateend);
        const hasAssignedUser = mission.user_assigned || false

        let missionStatus;
        if (now < startDate) missionStatus = 'soon';
        else if (now > endDate) missionStatus = 'past';
        else missionStatus = 'in_progress';

        if (missionStatus === 'soon' && hasAssignedUser) return 'cancel';
        if ((missionStatus === 'in_progress' || missionStatus === 'soon' || missionStatus === 'past') && !hasAssignedUser) return 'delete';
        return false;
    }

    const handleDeleteMission = () => {
        setObjID(infoMission._id)
        toggle('mission_delete')
    }

    const handleCancelMission = () => {
        setObjID(infoMission._id)
        toggle('mission_cancel')
    }

    // Obtenir les infos de l'intérimaire
    const getAssignedUserInfo = () => {
        if (assignedUser?.firstname || assignedUser?.lastname) {
            return { firstname: assignedUser.firstname, lastname: assignedUser.lastname };
        }
        if (infoMission?.userInfo?.[0]?.firstname || infoMission?.userInfo?.[0]?.lastname) {
            return { firstname: infoMission.userInfo[0].firstname, lastname: infoMission.userInfo[0].lastname };
        }
        if (infoMission?.user_assigned_infos?.firstname || infoMission?.user_assigned_infos?.lastname) {
            return { firstname: infoMission.user_assigned_infos.firstname, lastname: infoMission.user_assigned_infos.lastname };
        }
        if (infoMission?.employee?.[0]?.firstname || infoMission?.employee?.[0]?.lastname) {
            return { firstname: infoMission.employee[0].firstname, lastname: infoMission.employee[0].lastname };
        }
        return null;
    }

    // Composant InfoCard réutilisable
    const InfoCard = ({ icon: Icon, label, value, iconColor = "#6B7280" }) => (
        <div className="flex items-start gap-3">
            <div className="w-10 h-10 rounded-lg bg-gray-50 flex items-center justify-center shrink-0">
                <Icon wh={18} color={iconColor} />
            </div>
            <div className="flex-1 min-w-0">
                <p className="text-xs text-gray-500 mb-0.5">{label}</p>
                <p className="text-sm font-medium text-gray-900 truncate">{value || 'Non renseigné'}</p>
            </div>
        </div>
    );

    return (
        <PageForm>
            {isWaiting ? (
                <div className="animate-pulse">
                    <SubNavbar>
                        <div className="w-full flex items-center justify-between h-full">
                            <div className="flex items-center gap-4">
                                <div className="h-9 w-24 bg-gray-200 rounded-lg"></div>
                                <div className="h-6 w-48 bg-gray-200 rounded"></div>
                            </div>
                        </div>
                    </SubNavbar>
                    <div className="px-8 py-6">
                        <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-3 gap-8">
                            <div className="lg:col-span-2 space-y-6">
                                <div className="h-8 bg-gray-200 rounded w-2/3"></div>
                                <div className="h-4 bg-gray-200 rounded w-full"></div>
                                <div className="h-4 bg-gray-200 rounded w-3/4"></div>
                            </div>
                            <div className="space-y-4">
                                <div className="h-48 bg-gray-200 rounded-xl"></div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <>
                    {/* SubNavbar améliorée */}
                    <SubNavbar>
                        <div className="w-full flex items-center justify-between h-full">
                            <div className="flex items-center gap-4">
                                <Button size={'SM'} color={'SECONDARY'} onClick={() => navigate(-1)}>
                                    <div className="flex items-center gap-2">
                                        <ArrowLeft w={15} h={12} color={'#374151'}/>
                                        <span>Retour</span>
                                    </div>
                                </Button>
                            </div>
                            {shouldShowTrashButton(infoMission) && (
                                <Button 
                                    size={'SM'} 
                                    color={'SECONDARY'} 
                                    onClick={shouldShowTrashButton(infoMission) === 'cancel' ? handleCancelMission : handleDeleteMission}
                                >
                                    <div className="flex items-center gap-2">
                                        <CrossIcon wh={16} color={'#374151'}/>
                                        <span className="hidden sm:inline">Annuler la mission</span>
                                    </div>
                                </Button>
                            )}
                        </div>
                    </SubNavbar>
                    
                    {/* Contenu principal */}
                    <div className="px-8 py-6">
                        <div className="max-w-6xl mx-auto">
                            <div className="border border-gray-100 rounded-lg p-6">
                                {/* Titre de la mission */}
                                <div className="flex items-center gap-3 mb-6">
                                    <h1 className="text-2xl font-semibold text-gray-900">
                                        {infoMission?.title || 'Mission'}
                                    </h1>
                                    {infoMission?.id_mission && (
                                        <Chip type="INDICATOR" color="PRIMARY">
                                            n° {infoMission.id_mission}
                                        </Chip>
                                    )}
                                </div>
                                <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
                                {/* Colonne principale */}
                                <div className="lg:col-span-2 space-y-8">

                                    {/* Description */}
                                    {(infoMission?.desc || infoMission?.other) && (
                                        <>
                                            <section>
                                                <h2 className="text-base font-semibold text-gray-900 mb-3">Description du poste</h2>
                                                <div className="prose prose-gray max-w-none text-gray-600 leading-relaxed text-sm">
                                                    {infoMission?.desc && (
                                                        <div dangerouslySetInnerHTML={{__html: infoMission.desc}}></div>
                                                    )}
                                                    {infoMission?.other && (
                                                        <div className="mt-4" dangerouslySetInnerHTML={{__html: infoMission.other}}></div>
                                                    )}
                                                </div>
                                            </section>
                                            {(scheduleWeeks.length > 0 || 
                                              (infoMission?.info_temporary_activity || infoMission?.awaiting_recruitement || 
                                               infoMission?.replacement_employee || infoMission?.temporary_contract || 
                                               infoMission?.seasonal_employment || infoMission?.motif || infoMission?.reason) ||
                                              (infoMission?.language?.length > 0 || infoMission?.tools?.length > 0 || infoMission?.licences?.length > 0)) && (
                                                <hr className="border-gray-100" />
                                            )}
                                        </>
                                    )}

                                    {/* Planning */}
                                    {scheduleWeeks.length > 0 && (
                                        <>
                                            <section>
                                                <h2 className="text-base font-semibold text-gray-900 mb-3">Planning</h2>
                                                <div className="bg-white rounded-xl overflow-hidden">
                                                    {scheduleWeeks.map((scheduleWeek, index) => {
                                                        if(scheduleWeek.isNext !== undefined && scheduleWeek.isPrev !== undefined) {
                                                            return (
                                                                <ScheduleWeekListMission 
                                                                    key={index}
                                                                    indexScheduleWeek={index}
                                                                    scheduleWeek={scheduleWeek}
                                                                    isNext={scheduleWeek.isNext}
                                                                    isPrev={scheduleWeek.isPrev}
                                                                    isHidden={scheduleWeekDisplay !== index}
                                                                    isActualWeek={scheduleWeek.isActualWeek}
                                                                    setScheduleWeekDisplay={setScheduleWeekDisplay}
                                                                />
                                                            )
                                                        }
                                                        return null;
                                                    })}
                                                </div>
                                            </section>
                                            {((infoMission?.user_assigned && assignedUser) || 
                                              (infoMission?.info_temporary_activity || infoMission?.awaiting_recruitement || 
                                               infoMission?.replacement_employee || infoMission?.temporary_contract || 
                                               infoMission?.seasonal_employment || infoMission?.motif || infoMission?.reason) ||
                                              (infoMission?.language?.length > 0 || infoMission?.tools?.length > 0 || infoMission?.licences?.length > 0)) && (
                                                <hr className="border-gray-100" />
                                            )}
                                        </>
                                    )}

                                    {/* Intérimaire assigné */}
                                    <section>
                                        <h2 className="text-base font-semibold text-gray-900 mb-3">Intérimaire</h2>
                                        {infoMission?.user_assigned && (infoMission.user_assigned.firstname || infoMission.user_assigned.lastname || assignedUser) ? (
                                            <div className="bg-white rounded-xl border border-gray-100 p-4">
                                                <div className="flex items-center gap-4">
                                                    <div className="w-12 h-12 rounded-full bg-yellow-100 flex items-center justify-center">
                                                        <span className="text-lg font-semibold text-yellow-700">
                                                            {((infoMission.user_assigned.firstname || assignedUser?.firstname)?.charAt(0) || '') + ((infoMission.user_assigned.lastname || assignedUser?.lastname)?.charAt(0) || '')}
                                                        </span>
                                                    </div>
                                                    <div className="flex-1">
                                                        <p className="text-base font-semibold text-gray-900">
                                                            {infoMission.user_assigned.firstname || assignedUser?.firstname} {infoMission.user_assigned.lastname || assignedUser?.lastname}
                                                        </p>
                                                        {assignedUser?.email && (
                                                            <p className="text-sm text-gray-500">{assignedUser.email}</p>
                                                        )}
                                                    </div>
                                                    <RatingTempWorker 
                                                        isTutoCanBeDisplayed={false}
                                                        idMission={infoMission._id}
                                                        idTempWorker={infoMission.user_assigned._id || assignedUser?._id}
                                                        idTimeSheet={null}
                                                    />
                                                </div>
                                                {(assignedUser?.phone || assignedUser?.telephone) && (
                                                    <div className="mt-3 pt-3 border-t border-gray-100">
                                                        <div className="flex items-center gap-2">
                                                            <PhoneIcon wh={16} color="#6B7280" />
                                                            <span className="text-sm text-gray-600">{assignedUser.phone || assignedUser.telephone}</span>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        ) : (
                                            <div className="bg-gray-50 rounded-xl border border-gray-100 p-4">
                                                <div className="flex items-center gap-4">
                                                    <div className="w-12 h-12 rounded-full bg-gray-200 flex items-center justify-center">
                                                        <User wh={20} color="#9CA3AF" />
                                                    </div>
                                                    <div className="flex-1">
                                                        <p className="text-sm text-gray-500">Aucun intérimaire assigné</p>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </section>
                                    {((infoMission?.info_temporary_activity || infoMission?.awaiting_recruitement || 
                                       infoMission?.replacement_employee || infoMission?.temporary_contract || 
                                       infoMission?.seasonal_employment || infoMission?.motif || infoMission?.reason) ||
                                      (infoMission?.language?.length > 0 || infoMission?.tools?.length > 0 || infoMission?.licences?.length > 0)) && (
                                        <hr className="border-gray-100" />
                                    )}

                                    {/* Motif de recrutement */}
                                    {(infoMission?.info_temporary_activity || infoMission?.awaiting_recruitement || 
                                      infoMission?.replacement_employee || infoMission?.temporary_contract || 
                                      infoMission?.seasonal_employment || infoMission?.motif || infoMission?.reason) && (
                                        <>
                                            <section>
                                                <h2 className="text-base font-semibold text-gray-900 mb-3">Motif de recrutement</h2>
                                                
                                                {/* Accroissement temporaire d'activité */}
                                                {infoMission?.info_temporary_activity && (
                                                    <div className="bg-white border border-gray-100 rounded-lg p-4">
                                                        <h3 className="text-sm font-medium text-gray-900 mb-3">Accroissement temporaire d'activité</h3>
                                                        {typeof infoMission.info_temporary_activity === 'string' && infoMission.info_temporary_activity ? (
                                                            <p className="text-sm text-gray-600 leading-relaxed">{infoMission.info_temporary_activity}</p>
                                                        ) : infoMission.info_temporary_activity?.message ? (
                                                            <p className="text-sm text-gray-600 leading-relaxed">{infoMission.info_temporary_activity.message}</p>
                                                        ) : (
                                                            <p className="text-sm text-gray-500 italic">Aucun détail fourni</p>
                                                        )}
                                                    </div>
                                                )}

                                                {/* En attente de recrutement */}
                                                {infoMission?.awaiting_recruitement && (
                                                    <div className="bg-white border border-gray-100 rounded-lg p-4">
                                                        <h3 className="text-sm font-medium text-gray-900 mb-3">En attente de recrutement</h3>
                                                        <div className="space-y-2">
                                                            {(infoMission.awaiting_recruitement.firstname || infoMission.awaiting_recruitement.lastname || infoMission.awaiting_recruitement.name || infoMission.awaiting_recruitement.prenom) && (
                                                                <div className="flex items-start gap-2">
                                                                    <span className="text-sm font-medium text-gray-700 min-w-[100px]">Personne :</span>
                                                                    <span className="text-sm text-gray-600">{infoMission.awaiting_recruitement.firstname || infoMission.awaiting_recruitement.prenom} {infoMission.awaiting_recruitement.lastname || infoMission.awaiting_recruitement.name}</span>
                                                                </div>
                                                            )}
                                                            {infoMission.awaiting_recruitement.date && (
                                                                <div className="flex items-start gap-2">
                                                                    <span className="text-sm font-medium text-gray-700 min-w-[100px]">Date prévue :</span>
                                                                    <span className="text-sm text-gray-600">{dateWordShort(infoMission.awaiting_recruitement.date)}</span>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                )}

                                                {/* Remplacement d'un salarié absent */}
                                                {infoMission?.replacement_employee && (
                                                    <div className="bg-white border border-gray-100 rounded-lg p-4">
                                                        <h3 className="text-sm font-medium text-gray-900 mb-3">Remplacement d'un salarié absent</h3>
                                                        <div className="space-y-2">
                                                            {(infoMission.replacement_employee.firstname || infoMission.replacement_employee.lastname || infoMission.replacement_employee.name || infoMission.replacement_employee.prenom) && (
                                                                <div className="flex items-start gap-2">
                                                                    <span className="text-sm font-medium text-gray-700 min-w-[120px]">Salarié remplacé :</span>
                                                                    <span className="text-sm text-gray-600">{infoMission.replacement_employee.firstname || infoMission.replacement_employee.prenom} {infoMission.replacement_employee.lastname || infoMission.replacement_employee.name}</span>
                                                                </div>
                                                            )}
                                                            {infoMission.replacement_employee.poste && (
                                                                <div className="flex items-start gap-2">
                                                                    <span className="text-sm font-medium text-gray-700 min-w-[120px]">Poste :</span>
                                                                    <span className="text-sm text-gray-600">{infoMission.replacement_employee.poste}</span>
                                                                </div>
                                                            )}
                                                            {infoMission.replacement_employee.description && (
                                                                <div className="flex items-start gap-2">
                                                                    <span className="text-sm font-medium text-gray-700 min-w-[120px]">Motif :</span>
                                                                    <span className="text-sm text-gray-600 leading-relaxed">{infoMission.replacement_employee.description}</span>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                )}

                                                {/* Contrat temporaire d'usage */}
                                                {infoMission?.temporary_contract && (
                                                    <div className="bg-white border border-gray-100 rounded-lg p-4">
                                                        <h3 className="text-sm font-medium text-gray-900 mb-3">Contrat temporaire d'usage</h3>
                                                        {typeof infoMission.temporary_contract === 'string' && infoMission.temporary_contract ? (
                                                            <p className="text-sm text-gray-600 leading-relaxed">{infoMission.temporary_contract}</p>
                                                        ) : infoMission.temporary_contract?.message ? (
                                                            <p className="text-sm text-gray-600 leading-relaxed">{infoMission.temporary_contract.message}</p>
                                                        ) : (
                                                            <p className="text-sm text-gray-500 italic">Aucun détail fourni</p>
                                                        )}
                                                    </div>
                                                )}

                                                {/* Emploi à caractère saisonnier */}
                                                {infoMission?.seasonal_employment && (
                                                    <div className="bg-white border border-gray-100 rounded-lg p-4">
                                                        <h3 className="text-sm font-medium text-gray-900 mb-3">Emploi à caractère saisonnier</h3>
                                                        {typeof infoMission.seasonal_employment === 'string' && infoMission.seasonal_employment ? (
                                                            <p className="text-sm text-gray-600 leading-relaxed">{infoMission.seasonal_employment}</p>
                                                        ) : infoMission.seasonal_employment?.message ? (
                                                            <p className="text-sm text-gray-600 leading-relaxed">{infoMission.seasonal_employment.message}</p>
                                                        ) : (
                                                            <p className="text-sm text-gray-500 italic">Aucun détail fourni</p>
                                                        )}
                                                    </div>
                                                )}

                                                {/* Fallback: motif objet ou reason string */}
                                                {!infoMission?.info_temporary_activity && !infoMission?.awaiting_recruitement && 
                                                 !infoMission?.replacement_employee && !infoMission?.temporary_contract && 
                                                 !infoMission?.seasonal_employment && (infoMission?.motif || infoMission?.reason) && (
                                                    <div className="bg-white border border-gray-100 rounded-lg p-4">
                                                        <h3 className="text-sm font-medium text-gray-900 mb-3">
                                                                {infoMission?.reason || (typeof infoMission?.motif === 'string' ? infoMission.motif : 'Motif de recrutement')}
                                                            </h3>
                                                        {infoMission?.motif?.message ? (
                                                            <p className="text-sm text-gray-600 leading-relaxed">{infoMission.motif.message}</p>
                                                        ) : (
                                                            <p className="text-sm text-gray-500 italic">Aucun détail fourni</p>
                                                        )}
                                                    </div>
                                                )}
                                            </section>
                                            {(infoMission?.language?.length > 0 || infoMission?.tools?.length > 0 || infoMission?.licences?.length > 0) && (
                                                <hr className="border-gray-100" />
                                            )}
                                        </>
                                    )}

                                    {/* Pré-requis */}
                                    {(infoMission?.language?.length > 0 || infoMission?.tools?.length > 0 || infoMission?.licences?.length > 0) && (
                                        <section>
                                            <h2 className="text-base font-semibold text-gray-900 mb-3">Pré-requis</h2>
                                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                                {infoMission?.language?.length > 0 && (
                                                    <div className="mb-4">
                                                        <h3 className="font-semibold text-gray-900 mb-2">Langues</h3>
                                                        <ul className="list-disc list-inside space-y-1">
                                                            {infoMission.language.map((item, idx) => (
                                                                <li key={idx} className="text-sm text-gray-700">
                                                                    {item}
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    </div>
                                                )}
                                                
                                                {infoMission?.tools?.length > 0 && (
                                                    <div className="mb-4">
                                                        <h3 className="font-semibold text-gray-900 mb-2">Matériels requis</h3>
                                                        <ul className="list-disc list-inside space-y-1">
                                                            {infoMission.tools.slice(0, visibilityTools).map((item, idx) => (
                                                                <li key={idx} className="text-sm text-gray-700">
                                                                    {item}
                                                                </li>
                                                            ))}
                                                        </ul>
                                                        {infoMission.tools.length > 3 && (
                                                            <button 
                                                                className="text-yellow-600 text-sm mt-2 hover:underline font-medium"
                                                                onClick={handleShowExp}
                                                            >
                                                                {showTools ? 'Voir moins' : `+${infoMission.tools.length - 3} autres`}
                                                            </button>
                                                        )}
                                                    </div>
                                                )}

                                                {infoMission?.licences?.length > 0 && (
                                                    <div className="mb-4">
                                                        <h3 className="font-semibold text-gray-900 mb-2">Permis</h3>
                                                        <ul className="list-disc list-inside space-y-1">
                                                            {infoMission.licences.slice(0, visibilityLicences).map((item, idx) => (
                                                                <li key={idx} className="text-sm text-gray-700">
                                                                    {item}
                                                                </li>
                                                            ))}
                                                        </ul>
                                                        {infoMission.licences.length > 3 && (
                                                            <button 
                                                                className="text-yellow-600 text-sm mt-2 hover:underline font-medium"
                                                                onClick={handleShowLicences}
                                                            >
                                                                {showLicences ? 'Voir moins' : `+${infoMission.licences.length - 3} autres`}
                                                            </button>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        </section>
                                    )}
                                </div>

                                {/* Sidebar */}
                                <div className="lg:col-span-1">
                                    <div className="sticky top-32 space-y-4">
                                        {/* Carte infos principales */}
                                        <div className="bg-white rounded-xl border border-gray-100 p-5 space-y-5">
                                            <InfoCard 
                                                icon={Calendar} 
                                                label="Période" 
                                                value={`${dateWordShort(infoMission?.duration?.datestart)} → ${dateWordShort(infoMission?.duration?.dateend)}`}
                                                iconColor="#F59E0B"
                                            />
                                            <InfoCard 
                                                icon={Localisation} 
                                                label="Localisation" 
                                                value={`${infoMission?.address?.city || 'Non renseigné'}`}
                                                iconColor="#F59E0B"
                                            />
                                            <InfoCard 
                                                icon={Euro} 
                                                label="Rémunération" 
                                                value={infoMission?.salary?.wage_per_hour ? `${infoMission.salary.wage_per_hour} €/h` : 'Selon expérience'}
                                                iconColor="#F59E0B"
                                            />
                                            <InfoCard 
                                                icon={User} 
                                                label="Responsable" 
                                                value={infoMission?.contact?.name}
                                                iconColor="#F59E0B"
                                            />
                                        </div>

                                        {/* Adresse complète */}
                                        <div className="bg-white rounded-xl border border-gray-100 p-5">
                                            <h3 className="text-sm font-semibold text-gray-900 mb-3">Adresse de la mission</h3>
                                            <p className="text-sm text-gray-600 mb-4">
                                                {infoMission?.address?.street}<br/>
                                                {infoMission?.address?.postcode} {infoMission?.address?.city}
                                            </p>
                                            <a 
                                                href={`https://www.google.com/maps/search/?api=1&query=${infoMission?.address?.street} ${infoMission?.address?.postcode} ${infoMission?.address?.city}`}
                                                target='_blank'
                                                rel="noreferrer"
                                                className="block"
                                            >
                                                <Button color={'SECONDARY'} size={'SM'} className="w-full justify-center">
                                                    <Localisation wh={14} color={'#374151'}/>
                                                    <span className="ml-2">Voir sur Google Maps</span>
                                                </Button>
                                            </a>
                                        </div>

                                        {/* ID Mission */}
                                        <div className="text-center">
                                            <p className="text-xs text-gray-400">
                                                Mission #{infoMission?.id_mission} • Créée le {dateWordShort(infoMission?.createdAt)}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </PageForm>
    );
};

export default MissionFiche;
